import { Component, Inject } from '@angular/core'
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog'
import { DeleteNodeConfirmationDialogModel } from './delete-node-confirmation-dialog.model'

@Component({
    selector: 'app-delete-node-confirmation-dialog',
    templateUrl: './delete-node-confirmation-dialog.component.html',
    styleUrls: ['./delete-node-confirmation-dialog.component.scss'],
})
export class DeleteNodeConfirmationDialogComponent {
    constructor(
        private readonly dialogRef: DialogRef<boolean>,
        @Inject(DIALOG_DATA) readonly data: DeleteNodeConfirmationDialogModel
    ) {}

    onConfirm(): void {
        this.dialogRef.close(true)
    }

    onCancel(): void {
        this.dialogRef.close(false)
    }
}
